import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Avatar,
} from "@mui/material";
import { UseMagAdvertisment } from "./UseMagAdvertisment";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function UpdateMagAdv() {
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { validate, GetMagAdvByID, UpdateMagAdv } = UseMagAdvertisment();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    url: undefined,
    visibility: true,
    width1: undefined,
    height1: undefined,
  });

  const [imgState, setImgState] = useState({
    imageFile1: undefined,
    imageUrl1: undefined,
    imageFile2: undefined,
    imageUrl2: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    url: false,
  });

  const handleChangeImage1 = (e) => {
    const img = new Image();
    img.src = URL.createObjectURL(e.target.files[0]);
    img.onload = () => {
      setState({ ...state, width1: img.width, height1: img.height });
    };
    setImgState({
      ...imgState,
      imageFile1: e.target.files[0],
      imageUrl1: URL.createObjectURL(e.target.files[0]),
    });
  };

  const handleChangeImage2 = (e) => {
    setImgState({
      ...imgState,
      imageFile2: e.target.files[0],
      imageUrl2: URL.createObjectURL(e.target.files[0]),
    });
  };

  useEffect(() => {
    if (location.state?.id) {
      GetMagAdvByID(location.state.id, (callback) => {
        setImgState({
          ...imgState,
          imageUrl1: callback.image1,
          imageUrl2: callback.image2,
        });
        setState({
          id: callback.id,
          title: callback.title,
          url: callback.url,
          visibility: callback.visibility,
          width1: callback.width1,
          height1: callback.height1,
        });
      });
    }
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/magadvmanage" },
          {
            name: "ویرایش تبلیغ",
            url: "/magadvmanage/addMagAdv",
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span  5"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  5"}>
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.url ? state.url : ""}
              error={errorState.url}
              sx={{ textarea: { direction: "rtl" } }}
              label="لینک"
              size="small"
              multiline
              rows={3}
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, url: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span  7"}
            sx={{
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
              alignItems: isSmall ? "flex-start" : "center",
              gap: 5,
            }}
          >
            <Box component="label">
              <Avatar
                sx={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 3,
                  width: "400px",
                  height: "150px",
                  p: 1,
                }}
                src={
                  imgState.imageUrl1
                    ? imgState.imageUrl1
                    : "/static/img/nobanner.jpg"
                }
                alt="img"
              />
              <input
                type="file"
                id="img"
                name="avatarName"
                accept="image/*"
                multiple
                onChange={handleChangeImage1}
                hidden
              />
            </Box>
            <Box component="label">
              <Avatar
                sx={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 3,
                  width: "150px",
                  height: "150px",
                  p: 1,
                }}
                src={
                  imgState.imageUrl2
                    ? imgState.imageUrl2
                    : "/static/img/nobanner.png"
                }
                alt="img"
              />
              <input
                type="file"
                id="img"
                name="avatarName"
                accept="image/*"
                multiple
                onChange={handleChangeImage2}
                hidden
              />
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 6" : "span 2"}>
            <TextField
              fullWidth
              value={state.width1 ? state.width1 : ""}
              label="عرض"
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, width: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn={isSmall ? "span 6" : "span 2"}>
            <TextField
              fullWidth
              value={state.height1 ? state.height1 : ""}
              label="طول"
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, height: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <FormControlLabel
              checked={state.visibility}
              onChange={(evt) => {
                setState({ ...state, visibility: evt.target.checked });
              }}
              control={<Checkbox />}
              label="فعال"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  5"}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                sx={{ mr: 2, width: "100px" }}
                variant="contained"
                color="secondary"
                onClick={() => {
                  if (validate(state, setErrorState) == 200) {
                    setProgress(true);
                    UpdateMagAdv(
                      state,
                      imgState.imageFile1,
                      imgState.imageFile2,
                      () => {
                        setMsGotoLast(true);
                        navigate("/magadvmanage", {
                          state: { ...location.state, isBack: true },
                          replace: true,
                        });
                      }
                    );
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                sx={{ width: "100px" }}
                variant="outlined"
                color="secondary"
                onClick={() => {
                  navigate("/magadvmanage", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                }}
              >
                بازگشت
              </Button>
            </Box>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
